import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/wh-support-docs/wh-support-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Merative Integrated Care release notes provide brief details on new and updated features, resolved issues, and known issues.`}</p>
    <p>{`For versions that were released before 1 October 2022, see the Merative Integrated Care `}<a parentName="p" {...{
        "href": "https://www.merative.com/support/integrated-care/release-notes/release-notes"
      }}>{`release notes page`}</a>{` on the Merative website.`}</p>
    <p>{`Release notes for releases after 1 October 2022 are published on this page under the following section.`}</p>
    <h2>{`Release notes from 1 October 2022`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/wcm/MerativeIntegratedCare_ReleaseNotes_July2023.pdf"
        }}>{`Release notes July 2023`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/wcm/MerativeIntegratedCare_ReleaseNotes_June2023.pdf"
        }}>{`Release notes June 2023`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/wcm/MerativeIntegratedCare_ReleaseNotes_May2023.pdf"
        }}>{`Release notes May 2023`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/wcm/MerativeIntegratedCare_ReleaseNotes_April2023.pdf"
        }}>{`Release notes April 2023`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/wcm/MerativeIntegratedCare_ReleaseNotes_March2023.pdf"
        }}>{`Release notes March 2023`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/wcm/MerativeIntegratedCare_ReleaseNotes_February2023.pdf"
        }}>{`Release notes February 2023`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/wcm/MerativeIntegratedCare_ReleaseNotes_January2023.pdf"
        }}>{`Release notes January 2023`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/wh-support-docs/pdf/wcm/MerativeIntegratedCare_ReleaseNotes_November22.pdf"
        }}>{`Release notes November 2022`}</a></li>
    </ul>
    {
      /*
      </Row>
      <Row className="resource-card-group">
      <Column colMd={4} colLg={4} noGutterSm>
      <ResourceCard
         title="Previous release notes"
         subTitle="Release"
         actionIcon="launch"
         href="https://www.ibm.com/support/pages/node/6209656">
      </ResourceCard>
      </Column>
      </Row>
      */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      